module.exports = __webpack_public_path__ + "assets/CTA.38f3b4bb.png";